function parseDomains(source, separator) {
    let domains;
    if (source[0] !== "~" && !source.includes(separator)) {
        domains = new Map([
            ["", false],
            [source, true],
        ]);
    }
    else {
        domains = null;
        let hasIncludes = false;
        for (let domain of source.split(separator)) {
            if (domain === "") {
                continue;
            }
            let include;
            if (domain[0] === "~") {
                include = false;
                domain = domain.substring(1);
            }
            else {
                include = true;
                hasIncludes = true;
            }
            if (!domains) {
                domains = new Map();
            }
            domains.set(domain, include);
        }
        if (domains) {
            domains.set("", !hasIncludes);
        }
    }
    return domains;
}
function isIPAddress(hostname) {
    if (hostname[0] === "[" && hostname[hostname.length - 1] === "]") {
        return true;
    }
    return Number(hostname[hostname.length - 1]) >= 0 && /^\d+\.\d+\.\d+\.\d+$/.test(hostname);
}
function isValidIPv4Address(address) {
    return /^(((2[0-4]|1[0-9]|[1-9])?[0-9]|25[0-5])\.){4}$/.test(address + ".");
}
function isValidHostname(hostname) {
    if (isValidIPv4Address(hostname)) {
        return true;
    }
    if (hostname[0] === "[" && hostname[hostname.length - 1] === "]") {
        return true;
    }
    if (hostname[hostname.length - 1] === ".") {
        hostname = hostname.substring(0, hostname.length - 1);
    }
    if (hostname.length > 253) {
        return false;
    }
    const labels = hostname.split(".");
    for (const label of labels) {
        if (!/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(label)) {
            return false;
        }
    }
    if (!/\D/.test(labels[labels.length - 1])) {
        return false;
    }
    return true;
}
function* domainSuffixes(domain, includeBlank = false) {
    if (isIPAddress(domain)) {
        yield domain;
    }
    else {
        if (domain[domain.length - 1] === ".") {
            domain = domain.substring(0, domain.length - 1);
        }
        while (domain !== "") {
            yield domain;
            const dotIndex = domain.indexOf(".");
            domain = dotIndex === -1 ? "" : domain.substr(dotIndex + 1);
        }
    }
    if (includeBlank) {
        yield "";
    }
}
export function isActiveOnDomain(url, domainList) {
    if (!domainList) {
        return true;
    }
    const domains = parseDomains(domainList, ",");
    if (!domains) {
        return true;
    }
    const tabURL = new URL(url);
    let tabDomain = tabURL.hostname;
    if (tabDomain === null) {
        tabDomain = "";
    }
    else if (tabDomain[tabDomain.length - 1] === ".") {
        tabDomain = tabDomain.substring(0, tabDomain.length - 1);
    }
    if (!tabDomain) {
        return !!domains.get("");
    }
    for (tabDomain of domainSuffixes(tabDomain)) {
        const isDomainIncluded = domains.get(tabDomain);
        if (typeof isDomainIncluded !== "undefined") {
            return isDomainIncluded;
        }
    }
    return !!domains.get("");
}
export function isDomainList(list) {
    const domains = parseDomains(list, ",");
    if (domains === null) {
        return true;
    }
    return Array.from(domains.keys()).every((domain) => !domain || isValidHostname(domain));
}
